import { Component, OnInit, Input } from '@angular/core';
import { TeamReportServiceService } from './../team-report-service.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-team-implementer',
  templateUrl: './team-implementer.component.html',
  styleUrls: ['./team-implementer.component.scss']
})
export class TeamImplementerComponent implements OnInit {
	implementersTeam:any;
	clarifierTeam:any;
	@Input() members:any;
	env:any;

  	constructor(public service: TeamReportServiceService) { }

  	ngOnInit() {
  		this.env = environment;
  		this.implementersTeam = this.service.implementersTeam;
  		this.clarifierTeam = this.service.clarifierTeam;
  	}

}
